import {useEffect} from 'react';
import {useSearchParams} from '../../../router/compat';
import {useAuth} from '../../auth/context/AuthContext';
import {writeStoredFilters} from '../utils/ticketFilterStorage';

export function useFilterPersistence(): void {
	const [searchParams] = useSearchParams();
	const {user} = useAuth();

	useEffect(() => {
		if (!user?.id) return;
		if (searchParams.get('view') !== 'all') return;
		writeStoredFilters(user.id, searchParams);
	}, [searchParams, user]);
}
